import React from 'react';
import { useTranslation } from 'react-i18next';

import { StyledNotificationItemPlug } from './styled';

function NotificationItemPlug() {
	const { t } = useTranslation();
	return <StyledNotificationItemPlug>{t('notifications.important')}</StyledNotificationItemPlug>;
}

export default NotificationItemPlug;
